/* tslint:disable */
/* eslint-disable */
// this is an auto generated file. This will be overwritten

import * as APITypes from "../API";
type GeneratedMutation<InputType, OutputType> = string & {
  __generatedMutationInput: InputType;
  __generatedMutationOutput: OutputType;
};

export const createWarning = /* GraphQL */ `mutation CreateWarning(
  $input: CreateWarningInput!
  $condition: ModelWarningConditionInput
) {
  createWarning(input: $input, condition: $condition) {
    id
    title
    description
    group
    level
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.CreateWarningMutationVariables,
  APITypes.CreateWarningMutation
>;
export const updateWarning = /* GraphQL */ `mutation UpdateWarning(
  $input: UpdateWarningInput!
  $condition: ModelWarningConditionInput
) {
  updateWarning(input: $input, condition: $condition) {
    id
    title
    description
    group
    level
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.UpdateWarningMutationVariables,
  APITypes.UpdateWarningMutation
>;
export const deleteWarning = /* GraphQL */ `mutation DeleteWarning(
  $input: DeleteWarningInput!
  $condition: ModelWarningConditionInput
) {
  deleteWarning(input: $input, condition: $condition) {
    id
    title
    description
    group
    level
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.DeleteWarningMutationVariables,
  APITypes.DeleteWarningMutation
>;
export const createGroundWater = /* GraphQL */ `mutation CreateGroundWater(
  $input: CreateGroundWaterInput!
  $condition: ModelGroundWaterConditionInput
) {
  createGroundWater(input: $input, condition: $condition) {
    id
    altitude
    center {
      lat
      lon
      __typename
    }
    radius
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    owner
    __typename
  }
}
` as GeneratedMutation<
  APITypes.CreateGroundWaterMutationVariables,
  APITypes.CreateGroundWaterMutation
>;
export const updateGroundWater = /* GraphQL */ `mutation UpdateGroundWater(
  $input: UpdateGroundWaterInput!
  $condition: ModelGroundWaterConditionInput
) {
  updateGroundWater(input: $input, condition: $condition) {
    id
    altitude
    center {
      lat
      lon
      __typename
    }
    radius
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    owner
    __typename
  }
}
` as GeneratedMutation<
  APITypes.UpdateGroundWaterMutationVariables,
  APITypes.UpdateGroundWaterMutation
>;
export const deleteGroundWater = /* GraphQL */ `mutation DeleteGroundWater(
  $input: DeleteGroundWaterInput!
  $condition: ModelGroundWaterConditionInput
) {
  deleteGroundWater(input: $input, condition: $condition) {
    id
    altitude
    center {
      lat
      lon
      __typename
    }
    radius
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    owner
    __typename
  }
}
` as GeneratedMutation<
  APITypes.DeleteGroundWaterMutationVariables,
  APITypes.DeleteGroundWaterMutation
>;
export const createPlaceReport = /* GraphQL */ `mutation CreatePlaceReport(
  $input: CreatePlaceReportInput!
  $condition: ModelPlaceReportConditionInput
) {
  createPlaceReport(input: $input, condition: $condition) {
    owner
    id
    rating
    waterTemp
    visibility
    swell
    wind
    text
    date
    place {
      id
      data {
        name
        alternateNames
        location {
          lat
          lon
          __typename
        }
        locationKnown
        checked
        checkedBy
        spelioData {
          systemName
          reference
          source
          type
          notes
          caveRating
          highestCaveRating
          tourismPotential
          accessDetails
          verticalAccess
          explorationPotential
          disabledAccessPotential
          files
          labels
          goesToWater
          references {
            name
            text
            __typename
          }
          surveyedLength
          __typename
        }
        diveData {
          minDepth
          maxDepth
          waterType
          isTidal
          minTemp
          maxTemp
          difficulty
          entryDifficulty
          entryType
          __typename
        }
        wreckData {
          type
          built
          dateSunk
          length
          width
          draught
          __typename
        }
        address {
          streetNumber
          street
          suburb
          state
          country
          postcode
          timezone
          __typename
        }
        altitude
        warnings
        amenities {
          hasShowers
          hasToilets
          hasPhone
          food
          family
          parking
          __typename
        }
        __typename
      }
      userAccess
      groupAccess
      reports {
        items {
          owner
          id
          rating
          waterTemp
          visibility
          swell
          wind
          text
          date
          place {
            id
            userAccess
            groupAccess
            softDeleted
            scubaCollection
            caveCollection
            createdAt
            updatedAt
            _version
            _deleted
            _lastChangedAt
            __typename
          }
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          placeReportsId
          __typename
        }
        nextToken
        startedAt
        __typename
      }
      ratings {
        items {
          id
          rating
          place {
            id
            userAccess
            groupAccess
            softDeleted
            scubaCollection
            caveCollection
            createdAt
            updatedAt
            _version
            _deleted
            _lastChangedAt
            __typename
          }
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          placeRatingsId
          owner
          __typename
        }
        nextToken
        startedAt
        __typename
      }
      media {
        items {
          id
          owner
          groupAccess
          media {
            id
            contributorId
            mimeType
            name
            description
            contentType
            attribution
            attributionLink
            dateAdded
            dateCreated
            __typename
          }
          placeMediaId
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          __typename
        }
        nextToken
        startedAt
        __typename
      }
      softDeleted
      scubaCollection
      caveCollection
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    placeReportsId
    __typename
  }
}
` as GeneratedMutation<
  APITypes.CreatePlaceReportMutationVariables,
  APITypes.CreatePlaceReportMutation
>;
export const updatePlaceReport = /* GraphQL */ `mutation UpdatePlaceReport(
  $input: UpdatePlaceReportInput!
  $condition: ModelPlaceReportConditionInput
) {
  updatePlaceReport(input: $input, condition: $condition) {
    owner
    id
    rating
    waterTemp
    visibility
    swell
    wind
    text
    date
    place {
      id
      data {
        name
        alternateNames
        location {
          lat
          lon
          __typename
        }
        locationKnown
        checked
        checkedBy
        spelioData {
          systemName
          reference
          source
          type
          notes
          caveRating
          highestCaveRating
          tourismPotential
          accessDetails
          verticalAccess
          explorationPotential
          disabledAccessPotential
          files
          labels
          goesToWater
          references {
            name
            text
            __typename
          }
          surveyedLength
          __typename
        }
        diveData {
          minDepth
          maxDepth
          waterType
          isTidal
          minTemp
          maxTemp
          difficulty
          entryDifficulty
          entryType
          __typename
        }
        wreckData {
          type
          built
          dateSunk
          length
          width
          draught
          __typename
        }
        address {
          streetNumber
          street
          suburb
          state
          country
          postcode
          timezone
          __typename
        }
        altitude
        warnings
        amenities {
          hasShowers
          hasToilets
          hasPhone
          food
          family
          parking
          __typename
        }
        __typename
      }
      userAccess
      groupAccess
      reports {
        items {
          owner
          id
          rating
          waterTemp
          visibility
          swell
          wind
          text
          date
          place {
            id
            userAccess
            groupAccess
            softDeleted
            scubaCollection
            caveCollection
            createdAt
            updatedAt
            _version
            _deleted
            _lastChangedAt
            __typename
          }
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          placeReportsId
          __typename
        }
        nextToken
        startedAt
        __typename
      }
      ratings {
        items {
          id
          rating
          place {
            id
            userAccess
            groupAccess
            softDeleted
            scubaCollection
            caveCollection
            createdAt
            updatedAt
            _version
            _deleted
            _lastChangedAt
            __typename
          }
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          placeRatingsId
          owner
          __typename
        }
        nextToken
        startedAt
        __typename
      }
      media {
        items {
          id
          owner
          groupAccess
          media {
            id
            contributorId
            mimeType
            name
            description
            contentType
            attribution
            attributionLink
            dateAdded
            dateCreated
            __typename
          }
          placeMediaId
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          __typename
        }
        nextToken
        startedAt
        __typename
      }
      softDeleted
      scubaCollection
      caveCollection
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    placeReportsId
    __typename
  }
}
` as GeneratedMutation<
  APITypes.UpdatePlaceReportMutationVariables,
  APITypes.UpdatePlaceReportMutation
>;
export const deletePlaceReport = /* GraphQL */ `mutation DeletePlaceReport(
  $input: DeletePlaceReportInput!
  $condition: ModelPlaceReportConditionInput
) {
  deletePlaceReport(input: $input, condition: $condition) {
    owner
    id
    rating
    waterTemp
    visibility
    swell
    wind
    text
    date
    place {
      id
      data {
        name
        alternateNames
        location {
          lat
          lon
          __typename
        }
        locationKnown
        checked
        checkedBy
        spelioData {
          systemName
          reference
          source
          type
          notes
          caveRating
          highestCaveRating
          tourismPotential
          accessDetails
          verticalAccess
          explorationPotential
          disabledAccessPotential
          files
          labels
          goesToWater
          references {
            name
            text
            __typename
          }
          surveyedLength
          __typename
        }
        diveData {
          minDepth
          maxDepth
          waterType
          isTidal
          minTemp
          maxTemp
          difficulty
          entryDifficulty
          entryType
          __typename
        }
        wreckData {
          type
          built
          dateSunk
          length
          width
          draught
          __typename
        }
        address {
          streetNumber
          street
          suburb
          state
          country
          postcode
          timezone
          __typename
        }
        altitude
        warnings
        amenities {
          hasShowers
          hasToilets
          hasPhone
          food
          family
          parking
          __typename
        }
        __typename
      }
      userAccess
      groupAccess
      reports {
        items {
          owner
          id
          rating
          waterTemp
          visibility
          swell
          wind
          text
          date
          place {
            id
            userAccess
            groupAccess
            softDeleted
            scubaCollection
            caveCollection
            createdAt
            updatedAt
            _version
            _deleted
            _lastChangedAt
            __typename
          }
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          placeReportsId
          __typename
        }
        nextToken
        startedAt
        __typename
      }
      ratings {
        items {
          id
          rating
          place {
            id
            userAccess
            groupAccess
            softDeleted
            scubaCollection
            caveCollection
            createdAt
            updatedAt
            _version
            _deleted
            _lastChangedAt
            __typename
          }
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          placeRatingsId
          owner
          __typename
        }
        nextToken
        startedAt
        __typename
      }
      media {
        items {
          id
          owner
          groupAccess
          media {
            id
            contributorId
            mimeType
            name
            description
            contentType
            attribution
            attributionLink
            dateAdded
            dateCreated
            __typename
          }
          placeMediaId
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          __typename
        }
        nextToken
        startedAt
        __typename
      }
      softDeleted
      scubaCollection
      caveCollection
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    placeReportsId
    __typename
  }
}
` as GeneratedMutation<
  APITypes.DeletePlaceReportMutationVariables,
  APITypes.DeletePlaceReportMutation
>;
export const createPlaceRating = /* GraphQL */ `mutation CreatePlaceRating(
  $input: CreatePlaceRatingInput!
  $condition: ModelPlaceRatingConditionInput
) {
  createPlaceRating(input: $input, condition: $condition) {
    id
    rating
    place {
      id
      data {
        name
        alternateNames
        location {
          lat
          lon
          __typename
        }
        locationKnown
        checked
        checkedBy
        spelioData {
          systemName
          reference
          source
          type
          notes
          caveRating
          highestCaveRating
          tourismPotential
          accessDetails
          verticalAccess
          explorationPotential
          disabledAccessPotential
          files
          labels
          goesToWater
          references {
            name
            text
            __typename
          }
          surveyedLength
          __typename
        }
        diveData {
          minDepth
          maxDepth
          waterType
          isTidal
          minTemp
          maxTemp
          difficulty
          entryDifficulty
          entryType
          __typename
        }
        wreckData {
          type
          built
          dateSunk
          length
          width
          draught
          __typename
        }
        address {
          streetNumber
          street
          suburb
          state
          country
          postcode
          timezone
          __typename
        }
        altitude
        warnings
        amenities {
          hasShowers
          hasToilets
          hasPhone
          food
          family
          parking
          __typename
        }
        __typename
      }
      userAccess
      groupAccess
      reports {
        items {
          owner
          id
          rating
          waterTemp
          visibility
          swell
          wind
          text
          date
          place {
            id
            userAccess
            groupAccess
            softDeleted
            scubaCollection
            caveCollection
            createdAt
            updatedAt
            _version
            _deleted
            _lastChangedAt
            __typename
          }
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          placeReportsId
          __typename
        }
        nextToken
        startedAt
        __typename
      }
      ratings {
        items {
          id
          rating
          place {
            id
            userAccess
            groupAccess
            softDeleted
            scubaCollection
            caveCollection
            createdAt
            updatedAt
            _version
            _deleted
            _lastChangedAt
            __typename
          }
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          placeRatingsId
          owner
          __typename
        }
        nextToken
        startedAt
        __typename
      }
      media {
        items {
          id
          owner
          groupAccess
          media {
            id
            contributorId
            mimeType
            name
            description
            contentType
            attribution
            attributionLink
            dateAdded
            dateCreated
            __typename
          }
          placeMediaId
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          __typename
        }
        nextToken
        startedAt
        __typename
      }
      softDeleted
      scubaCollection
      caveCollection
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    placeRatingsId
    owner
    __typename
  }
}
` as GeneratedMutation<
  APITypes.CreatePlaceRatingMutationVariables,
  APITypes.CreatePlaceRatingMutation
>;
export const updatePlaceRating = /* GraphQL */ `mutation UpdatePlaceRating(
  $input: UpdatePlaceRatingInput!
  $condition: ModelPlaceRatingConditionInput
) {
  updatePlaceRating(input: $input, condition: $condition) {
    id
    rating
    place {
      id
      data {
        name
        alternateNames
        location {
          lat
          lon
          __typename
        }
        locationKnown
        checked
        checkedBy
        spelioData {
          systemName
          reference
          source
          type
          notes
          caveRating
          highestCaveRating
          tourismPotential
          accessDetails
          verticalAccess
          explorationPotential
          disabledAccessPotential
          files
          labels
          goesToWater
          references {
            name
            text
            __typename
          }
          surveyedLength
          __typename
        }
        diveData {
          minDepth
          maxDepth
          waterType
          isTidal
          minTemp
          maxTemp
          difficulty
          entryDifficulty
          entryType
          __typename
        }
        wreckData {
          type
          built
          dateSunk
          length
          width
          draught
          __typename
        }
        address {
          streetNumber
          street
          suburb
          state
          country
          postcode
          timezone
          __typename
        }
        altitude
        warnings
        amenities {
          hasShowers
          hasToilets
          hasPhone
          food
          family
          parking
          __typename
        }
        __typename
      }
      userAccess
      groupAccess
      reports {
        items {
          owner
          id
          rating
          waterTemp
          visibility
          swell
          wind
          text
          date
          place {
            id
            userAccess
            groupAccess
            softDeleted
            scubaCollection
            caveCollection
            createdAt
            updatedAt
            _version
            _deleted
            _lastChangedAt
            __typename
          }
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          placeReportsId
          __typename
        }
        nextToken
        startedAt
        __typename
      }
      ratings {
        items {
          id
          rating
          place {
            id
            userAccess
            groupAccess
            softDeleted
            scubaCollection
            caveCollection
            createdAt
            updatedAt
            _version
            _deleted
            _lastChangedAt
            __typename
          }
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          placeRatingsId
          owner
          __typename
        }
        nextToken
        startedAt
        __typename
      }
      media {
        items {
          id
          owner
          groupAccess
          media {
            id
            contributorId
            mimeType
            name
            description
            contentType
            attribution
            attributionLink
            dateAdded
            dateCreated
            __typename
          }
          placeMediaId
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          __typename
        }
        nextToken
        startedAt
        __typename
      }
      softDeleted
      scubaCollection
      caveCollection
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    placeRatingsId
    owner
    __typename
  }
}
` as GeneratedMutation<
  APITypes.UpdatePlaceRatingMutationVariables,
  APITypes.UpdatePlaceRatingMutation
>;
export const deletePlaceRating = /* GraphQL */ `mutation DeletePlaceRating(
  $input: DeletePlaceRatingInput!
  $condition: ModelPlaceRatingConditionInput
) {
  deletePlaceRating(input: $input, condition: $condition) {
    id
    rating
    place {
      id
      data {
        name
        alternateNames
        location {
          lat
          lon
          __typename
        }
        locationKnown
        checked
        checkedBy
        spelioData {
          systemName
          reference
          source
          type
          notes
          caveRating
          highestCaveRating
          tourismPotential
          accessDetails
          verticalAccess
          explorationPotential
          disabledAccessPotential
          files
          labels
          goesToWater
          references {
            name
            text
            __typename
          }
          surveyedLength
          __typename
        }
        diveData {
          minDepth
          maxDepth
          waterType
          isTidal
          minTemp
          maxTemp
          difficulty
          entryDifficulty
          entryType
          __typename
        }
        wreckData {
          type
          built
          dateSunk
          length
          width
          draught
          __typename
        }
        address {
          streetNumber
          street
          suburb
          state
          country
          postcode
          timezone
          __typename
        }
        altitude
        warnings
        amenities {
          hasShowers
          hasToilets
          hasPhone
          food
          family
          parking
          __typename
        }
        __typename
      }
      userAccess
      groupAccess
      reports {
        items {
          owner
          id
          rating
          waterTemp
          visibility
          swell
          wind
          text
          date
          place {
            id
            userAccess
            groupAccess
            softDeleted
            scubaCollection
            caveCollection
            createdAt
            updatedAt
            _version
            _deleted
            _lastChangedAt
            __typename
          }
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          placeReportsId
          __typename
        }
        nextToken
        startedAt
        __typename
      }
      ratings {
        items {
          id
          rating
          place {
            id
            userAccess
            groupAccess
            softDeleted
            scubaCollection
            caveCollection
            createdAt
            updatedAt
            _version
            _deleted
            _lastChangedAt
            __typename
          }
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          placeRatingsId
          owner
          __typename
        }
        nextToken
        startedAt
        __typename
      }
      media {
        items {
          id
          owner
          groupAccess
          media {
            id
            contributorId
            mimeType
            name
            description
            contentType
            attribution
            attributionLink
            dateAdded
            dateCreated
            __typename
          }
          placeMediaId
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          __typename
        }
        nextToken
        startedAt
        __typename
      }
      softDeleted
      scubaCollection
      caveCollection
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    placeRatingsId
    owner
    __typename
  }
}
` as GeneratedMutation<
  APITypes.DeletePlaceRatingMutationVariables,
  APITypes.DeletePlaceRatingMutation
>;
export const createPlaceMediaItem = /* GraphQL */ `mutation CreatePlaceMediaItem(
  $input: CreatePlaceMediaItemInput!
  $condition: ModelPlaceMediaItemConditionInput
) {
  createPlaceMediaItem(input: $input, condition: $condition) {
    id
    owner
    groupAccess
    media {
      id
      contributorId
      mimeType
      file {
        bucket
        region
        key
        __typename
      }
      thumbnail_256px {
        bucket
        region
        key
        __typename
      }
      thumbnail_512px {
        bucket
        region
        key
        __typename
      }
      thumbnail_1024px {
        bucket
        region
        key
        __typename
      }
      name
      description
      contentType
      attribution
      attributionLink
      dateAdded
      dateCreated
      __typename
    }
    placeMediaId
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.CreatePlaceMediaItemMutationVariables,
  APITypes.CreatePlaceMediaItemMutation
>;
export const updatePlaceMediaItem = /* GraphQL */ `mutation UpdatePlaceMediaItem(
  $input: UpdatePlaceMediaItemInput!
  $condition: ModelPlaceMediaItemConditionInput
) {
  updatePlaceMediaItem(input: $input, condition: $condition) {
    id
    owner
    groupAccess
    media {
      id
      contributorId
      mimeType
      file {
        bucket
        region
        key
        __typename
      }
      thumbnail_256px {
        bucket
        region
        key
        __typename
      }
      thumbnail_512px {
        bucket
        region
        key
        __typename
      }
      thumbnail_1024px {
        bucket
        region
        key
        __typename
      }
      name
      description
      contentType
      attribution
      attributionLink
      dateAdded
      dateCreated
      __typename
    }
    placeMediaId
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.UpdatePlaceMediaItemMutationVariables,
  APITypes.UpdatePlaceMediaItemMutation
>;
export const deletePlaceMediaItem = /* GraphQL */ `mutation DeletePlaceMediaItem(
  $input: DeletePlaceMediaItemInput!
  $condition: ModelPlaceMediaItemConditionInput
) {
  deletePlaceMediaItem(input: $input, condition: $condition) {
    id
    owner
    groupAccess
    media {
      id
      contributorId
      mimeType
      file {
        bucket
        region
        key
        __typename
      }
      thumbnail_256px {
        bucket
        region
        key
        __typename
      }
      thumbnail_512px {
        bucket
        region
        key
        __typename
      }
      thumbnail_1024px {
        bucket
        region
        key
        __typename
      }
      name
      description
      contentType
      attribution
      attributionLink
      dateAdded
      dateCreated
      __typename
    }
    placeMediaId
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.DeletePlaceMediaItemMutationVariables,
  APITypes.DeletePlaceMediaItemMutation
>;
export const createPlace = /* GraphQL */ `mutation CreatePlace(
  $input: CreatePlaceInput!
  $condition: ModelPlaceConditionInput
) {
  createPlace(input: $input, condition: $condition) {
    id
    data {
      name
      alternateNames
      location {
        lat
        lon
        __typename
      }
      locationKnown
      checked
      checkedBy
      spelioData {
        systemName
        reference
        source
        type
        notes
        caveRating
        highestCaveRating
        tourismPotential
        accessDetails
        verticalAccess
        explorationPotential
        disabledAccessPotential
        files
        labels
        goesToWater
        references {
          name
          text
          __typename
        }
        surveyedLength
        __typename
      }
      diveData {
        minDepth
        maxDepth
        waterType
        isTidal
        minTemp
        maxTemp
        difficulty
        entryDifficulty
        entryType
        __typename
      }
      wreckData {
        type
        built
        dateSunk
        length
        width
        draught
        __typename
      }
      address {
        streetNumber
        street
        suburb
        state
        country
        postcode
        timezone
        __typename
      }
      altitude
      warnings
      amenities {
        hasShowers
        hasToilets
        hasPhone
        food
        family
        parking
        __typename
      }
      __typename
    }
    userAccess
    groupAccess
    reports {
      items {
        owner
        id
        rating
        waterTemp
        visibility
        swell
        wind
        text
        date
        place {
          id
          data {
            name
            alternateNames
            locationKnown
            checked
            checkedBy
            altitude
            warnings
            __typename
          }
          userAccess
          groupAccess
          reports {
            nextToken
            startedAt
            __typename
          }
          ratings {
            nextToken
            startedAt
            __typename
          }
          media {
            nextToken
            startedAt
            __typename
          }
          softDeleted
          scubaCollection
          caveCollection
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          __typename
        }
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        placeReportsId
        __typename
      }
      nextToken
      startedAt
      __typename
    }
    ratings {
      items {
        id
        rating
        place {
          id
          data {
            name
            alternateNames
            locationKnown
            checked
            checkedBy
            altitude
            warnings
            __typename
          }
          userAccess
          groupAccess
          reports {
            nextToken
            startedAt
            __typename
          }
          ratings {
            nextToken
            startedAt
            __typename
          }
          media {
            nextToken
            startedAt
            __typename
          }
          softDeleted
          scubaCollection
          caveCollection
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          __typename
        }
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        placeRatingsId
        owner
        __typename
      }
      nextToken
      startedAt
      __typename
    }
    media {
      items {
        id
        owner
        groupAccess
        media {
          id
          contributorId
          mimeType
          file {
            bucket
            region
            key
            __typename
          }
          thumbnail_256px {
            bucket
            region
            key
            __typename
          }
          thumbnail_512px {
            bucket
            region
            key
            __typename
          }
          thumbnail_1024px {
            bucket
            region
            key
            __typename
          }
          name
          description
          contentType
          attribution
          attributionLink
          dateAdded
          dateCreated
          __typename
        }
        placeMediaId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      nextToken
      startedAt
      __typename
    }
    softDeleted
    scubaCollection
    caveCollection
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.CreatePlaceMutationVariables,
  APITypes.CreatePlaceMutation
>;
export const updatePlace = /* GraphQL */ `mutation UpdatePlace(
  $input: UpdatePlaceInput!
  $condition: ModelPlaceConditionInput
) {
  updatePlace(input: $input, condition: $condition) {
    id
    data {
      name
      alternateNames
      location {
        lat
        lon
        __typename
      }
      locationKnown
      checked
      checkedBy
      spelioData {
        systemName
        reference
        source
        type
        notes
        caveRating
        highestCaveRating
        tourismPotential
        accessDetails
        verticalAccess
        explorationPotential
        disabledAccessPotential
        files
        labels
        goesToWater
        references {
          name
          text
          __typename
        }
        surveyedLength
        __typename
      }
      diveData {
        minDepth
        maxDepth
        waterType
        isTidal
        minTemp
        maxTemp
        difficulty
        entryDifficulty
        entryType
        __typename
      }
      wreckData {
        type
        built
        dateSunk
        length
        width
        draught
        __typename
      }
      address {
        streetNumber
        street
        suburb
        state
        country
        postcode
        timezone
        __typename
      }
      altitude
      warnings
      amenities {
        hasShowers
        hasToilets
        hasPhone
        food
        family
        parking
        __typename
      }
      __typename
    }
    userAccess
    groupAccess
    reports {
      items {
        owner
        id
        rating
        waterTemp
        visibility
        swell
        wind
        text
        date
        place {
          id
          data {
            name
            alternateNames
            locationKnown
            checked
            checkedBy
            altitude
            warnings
            __typename
          }
          userAccess
          groupAccess
          reports {
            nextToken
            startedAt
            __typename
          }
          ratings {
            nextToken
            startedAt
            __typename
          }
          media {
            nextToken
            startedAt
            __typename
          }
          softDeleted
          scubaCollection
          caveCollection
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          __typename
        }
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        placeReportsId
        __typename
      }
      nextToken
      startedAt
      __typename
    }
    ratings {
      items {
        id
        rating
        place {
          id
          data {
            name
            alternateNames
            locationKnown
            checked
            checkedBy
            altitude
            warnings
            __typename
          }
          userAccess
          groupAccess
          reports {
            nextToken
            startedAt
            __typename
          }
          ratings {
            nextToken
            startedAt
            __typename
          }
          media {
            nextToken
            startedAt
            __typename
          }
          softDeleted
          scubaCollection
          caveCollection
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          __typename
        }
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        placeRatingsId
        owner
        __typename
      }
      nextToken
      startedAt
      __typename
    }
    media {
      items {
        id
        owner
        groupAccess
        media {
          id
          contributorId
          mimeType
          file {
            bucket
            region
            key
            __typename
          }
          thumbnail_256px {
            bucket
            region
            key
            __typename
          }
          thumbnail_512px {
            bucket
            region
            key
            __typename
          }
          thumbnail_1024px {
            bucket
            region
            key
            __typename
          }
          name
          description
          contentType
          attribution
          attributionLink
          dateAdded
          dateCreated
          __typename
        }
        placeMediaId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      nextToken
      startedAt
      __typename
    }
    softDeleted
    scubaCollection
    caveCollection
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.UpdatePlaceMutationVariables,
  APITypes.UpdatePlaceMutation
>;
export const deletePlace = /* GraphQL */ `mutation DeletePlace(
  $input: DeletePlaceInput!
  $condition: ModelPlaceConditionInput
) {
  deletePlace(input: $input, condition: $condition) {
    id
    data {
      name
      alternateNames
      location {
        lat
        lon
        __typename
      }
      locationKnown
      checked
      checkedBy
      spelioData {
        systemName
        reference
        source
        type
        notes
        caveRating
        highestCaveRating
        tourismPotential
        accessDetails
        verticalAccess
        explorationPotential
        disabledAccessPotential
        files
        labels
        goesToWater
        references {
          name
          text
          __typename
        }
        surveyedLength
        __typename
      }
      diveData {
        minDepth
        maxDepth
        waterType
        isTidal
        minTemp
        maxTemp
        difficulty
        entryDifficulty
        entryType
        __typename
      }
      wreckData {
        type
        built
        dateSunk
        length
        width
        draught
        __typename
      }
      address {
        streetNumber
        street
        suburb
        state
        country
        postcode
        timezone
        __typename
      }
      altitude
      warnings
      amenities {
        hasShowers
        hasToilets
        hasPhone
        food
        family
        parking
        __typename
      }
      __typename
    }
    userAccess
    groupAccess
    reports {
      items {
        owner
        id
        rating
        waterTemp
        visibility
        swell
        wind
        text
        date
        place {
          id
          data {
            name
            alternateNames
            locationKnown
            checked
            checkedBy
            altitude
            warnings
            __typename
          }
          userAccess
          groupAccess
          reports {
            nextToken
            startedAt
            __typename
          }
          ratings {
            nextToken
            startedAt
            __typename
          }
          media {
            nextToken
            startedAt
            __typename
          }
          softDeleted
          scubaCollection
          caveCollection
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          __typename
        }
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        placeReportsId
        __typename
      }
      nextToken
      startedAt
      __typename
    }
    ratings {
      items {
        id
        rating
        place {
          id
          data {
            name
            alternateNames
            locationKnown
            checked
            checkedBy
            altitude
            warnings
            __typename
          }
          userAccess
          groupAccess
          reports {
            nextToken
            startedAt
            __typename
          }
          ratings {
            nextToken
            startedAt
            __typename
          }
          media {
            nextToken
            startedAt
            __typename
          }
          softDeleted
          scubaCollection
          caveCollection
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          __typename
        }
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        placeRatingsId
        owner
        __typename
      }
      nextToken
      startedAt
      __typename
    }
    media {
      items {
        id
        owner
        groupAccess
        media {
          id
          contributorId
          mimeType
          file {
            bucket
            region
            key
            __typename
          }
          thumbnail_256px {
            bucket
            region
            key
            __typename
          }
          thumbnail_512px {
            bucket
            region
            key
            __typename
          }
          thumbnail_1024px {
            bucket
            region
            key
            __typename
          }
          name
          description
          contentType
          attribution
          attributionLink
          dateAdded
          dateCreated
          __typename
        }
        placeMediaId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      nextToken
      startedAt
      __typename
    }
    softDeleted
    scubaCollection
    caveCollection
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.DeletePlaceMutationVariables,
  APITypes.DeletePlaceMutation
>;
export const createJournal = /* GraphQL */ `mutation CreateJournal(
  $input: CreateJournalInput!
  $condition: ModelJournalConditionInput
) {
  createJournal(input: $input, condition: $condition) {
    id
    addedAt
    scubaCollection
    caveCollection
    modifications {
      action
      model
      modelId
      modelName
      detail
      collections
      __typename
    }
    modification {
      action
      model
      modelId
      modelName
      detail
      collections
      __typename
    }
    userAccess
    groupAccess
    contributor
    owner
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.CreateJournalMutationVariables,
  APITypes.CreateJournalMutation
>;
export const updateJournal = /* GraphQL */ `mutation UpdateJournal(
  $input: UpdateJournalInput!
  $condition: ModelJournalConditionInput
) {
  updateJournal(input: $input, condition: $condition) {
    id
    addedAt
    scubaCollection
    caveCollection
    modifications {
      action
      model
      modelId
      modelName
      detail
      collections
      __typename
    }
    modification {
      action
      model
      modelId
      modelName
      detail
      collections
      __typename
    }
    userAccess
    groupAccess
    contributor
    owner
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.UpdateJournalMutationVariables,
  APITypes.UpdateJournalMutation
>;
export const deleteJournal = /* GraphQL */ `mutation DeleteJournal(
  $input: DeleteJournalInput!
  $condition: ModelJournalConditionInput
) {
  deleteJournal(input: $input, condition: $condition) {
    id
    addedAt
    scubaCollection
    caveCollection
    modifications {
      action
      model
      modelId
      modelName
      detail
      collections
      __typename
    }
    modification {
      action
      model
      modelId
      modelName
      detail
      collections
      __typename
    }
    userAccess
    groupAccess
    contributor
    owner
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.DeleteJournalMutationVariables,
  APITypes.DeleteJournalMutation
>;
export const createUserInfo = /* GraphQL */ `mutation CreateUserInfo(
  $input: CreateUserInfoInput!
  $condition: ModelUserInfoConditionInput
) {
  createUserInfo(input: $input, condition: $condition) {
    id
    avatar {
      id
      contributorId
      mimeType
      file {
        bucket
        region
        key
        __typename
      }
      thumbnail_256px {
        bucket
        region
        key
        __typename
      }
      thumbnail_512px {
        bucket
        region
        key
        __typename
      }
      thumbnail_1024px {
        bucket
        region
        key
        __typename
      }
      name
      description
      contentType
      attribution
      attributionLink
      dateAdded
      dateCreated
      __typename
    }
    banner {
      id
      contributorId
      mimeType
      file {
        bucket
        region
        key
        __typename
      }
      thumbnail_256px {
        bucket
        region
        key
        __typename
      }
      thumbnail_512px {
        bucket
        region
        key
        __typename
      }
      thumbnail_1024px {
        bucket
        region
        key
        __typename
      }
      name
      description
      contentType
      attribution
      attributionLink
      dateAdded
      dateCreated
      __typename
    }
    displayName
    navigationAccuracy
    displayUnits
    socials {
      website
      facebook
      x
      blueSky
      instagram
      __typename
    }
    isTestAccount
    bio
    owner
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.CreateUserInfoMutationVariables,
  APITypes.CreateUserInfoMutation
>;
export const updateUserInfo = /* GraphQL */ `mutation UpdateUserInfo(
  $input: UpdateUserInfoInput!
  $condition: ModelUserInfoConditionInput
) {
  updateUserInfo(input: $input, condition: $condition) {
    id
    avatar {
      id
      contributorId
      mimeType
      file {
        bucket
        region
        key
        __typename
      }
      thumbnail_256px {
        bucket
        region
        key
        __typename
      }
      thumbnail_512px {
        bucket
        region
        key
        __typename
      }
      thumbnail_1024px {
        bucket
        region
        key
        __typename
      }
      name
      description
      contentType
      attribution
      attributionLink
      dateAdded
      dateCreated
      __typename
    }
    banner {
      id
      contributorId
      mimeType
      file {
        bucket
        region
        key
        __typename
      }
      thumbnail_256px {
        bucket
        region
        key
        __typename
      }
      thumbnail_512px {
        bucket
        region
        key
        __typename
      }
      thumbnail_1024px {
        bucket
        region
        key
        __typename
      }
      name
      description
      contentType
      attribution
      attributionLink
      dateAdded
      dateCreated
      __typename
    }
    displayName
    navigationAccuracy
    displayUnits
    socials {
      website
      facebook
      x
      blueSky
      instagram
      __typename
    }
    isTestAccount
    bio
    owner
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.UpdateUserInfoMutationVariables,
  APITypes.UpdateUserInfoMutation
>;
export const deleteUserInfo = /* GraphQL */ `mutation DeleteUserInfo(
  $input: DeleteUserInfoInput!
  $condition: ModelUserInfoConditionInput
) {
  deleteUserInfo(input: $input, condition: $condition) {
    id
    avatar {
      id
      contributorId
      mimeType
      file {
        bucket
        region
        key
        __typename
      }
      thumbnail_256px {
        bucket
        region
        key
        __typename
      }
      thumbnail_512px {
        bucket
        region
        key
        __typename
      }
      thumbnail_1024px {
        bucket
        region
        key
        __typename
      }
      name
      description
      contentType
      attribution
      attributionLink
      dateAdded
      dateCreated
      __typename
    }
    banner {
      id
      contributorId
      mimeType
      file {
        bucket
        region
        key
        __typename
      }
      thumbnail_256px {
        bucket
        region
        key
        __typename
      }
      thumbnail_512px {
        bucket
        region
        key
        __typename
      }
      thumbnail_1024px {
        bucket
        region
        key
        __typename
      }
      name
      description
      contentType
      attribution
      attributionLink
      dateAdded
      dateCreated
      __typename
    }
    displayName
    navigationAccuracy
    displayUnits
    socials {
      website
      facebook
      x
      blueSky
      instagram
      __typename
    }
    isTestAccount
    bio
    owner
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.DeleteUserInfoMutationVariables,
  APITypes.DeleteUserInfoMutation
>;
export const createUserFilter = /* GraphQL */ `mutation CreateUserFilter(
  $input: CreateUserFilterInput!
  $condition: ModelUserFilterConditionInput
) {
  createUserFilter(input: $input, condition: $condition) {
    id
    name
    filterVersion
    filter
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    owner
    __typename
  }
}
` as GeneratedMutation<
  APITypes.CreateUserFilterMutationVariables,
  APITypes.CreateUserFilterMutation
>;
export const updateUserFilter = /* GraphQL */ `mutation UpdateUserFilter(
  $input: UpdateUserFilterInput!
  $condition: ModelUserFilterConditionInput
) {
  updateUserFilter(input: $input, condition: $condition) {
    id
    name
    filterVersion
    filter
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    owner
    __typename
  }
}
` as GeneratedMutation<
  APITypes.UpdateUserFilterMutationVariables,
  APITypes.UpdateUserFilterMutation
>;
export const deleteUserFilter = /* GraphQL */ `mutation DeleteUserFilter(
  $input: DeleteUserFilterInput!
  $condition: ModelUserFilterConditionInput
) {
  deleteUserFilter(input: $input, condition: $condition) {
    id
    name
    filterVersion
    filter
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    owner
    __typename
  }
}
` as GeneratedMutation<
  APITypes.DeleteUserFilterMutationVariables,
  APITypes.DeleteUserFilterMutation
>;
export const createPublicFilter = /* GraphQL */ `mutation CreatePublicFilter(
  $input: CreatePublicFilterInput!
  $condition: ModelPublicFilterConditionInput
) {
  createPublicFilter(input: $input, condition: $condition) {
    id
    name
    filterVersion
    filter
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.CreatePublicFilterMutationVariables,
  APITypes.CreatePublicFilterMutation
>;
export const updatePublicFilter = /* GraphQL */ `mutation UpdatePublicFilter(
  $input: UpdatePublicFilterInput!
  $condition: ModelPublicFilterConditionInput
) {
  updatePublicFilter(input: $input, condition: $condition) {
    id
    name
    filterVersion
    filter
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.UpdatePublicFilterMutationVariables,
  APITypes.UpdatePublicFilterMutation
>;
export const deletePublicFilter = /* GraphQL */ `mutation DeletePublicFilter(
  $input: DeletePublicFilterInput!
  $condition: ModelPublicFilterConditionInput
) {
  deletePublicFilter(input: $input, condition: $condition) {
    id
    name
    filterVersion
    filter
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.DeletePublicFilterMutationVariables,
  APITypes.DeletePublicFilterMutation
>;
export const createModerationRequest = /* GraphQL */ `mutation CreateModerationRequest(
  $input: CreateModerationRequestInput!
  $condition: ModelModerationRequestConditionInput
) {
  createModerationRequest(input: $input, condition: $condition) {
    id
    anonymous
    payload
    type
    status
    groupAccess
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    owner
    __typename
  }
}
` as GeneratedMutation<
  APITypes.CreateModerationRequestMutationVariables,
  APITypes.CreateModerationRequestMutation
>;
export const updateModerationRequest = /* GraphQL */ `mutation UpdateModerationRequest(
  $input: UpdateModerationRequestInput!
  $condition: ModelModerationRequestConditionInput
) {
  updateModerationRequest(input: $input, condition: $condition) {
    id
    anonymous
    payload
    type
    status
    groupAccess
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    owner
    __typename
  }
}
` as GeneratedMutation<
  APITypes.UpdateModerationRequestMutationVariables,
  APITypes.UpdateModerationRequestMutation
>;
export const deleteModerationRequest = /* GraphQL */ `mutation DeleteModerationRequest(
  $input: DeleteModerationRequestInput!
  $condition: ModelModerationRequestConditionInput
) {
  deleteModerationRequest(input: $input, condition: $condition) {
    id
    anonymous
    payload
    type
    status
    groupAccess
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    owner
    __typename
  }
}
` as GeneratedMutation<
  APITypes.DeleteModerationRequestMutationVariables,
  APITypes.DeleteModerationRequestMutation
>;
export const createPlaceListEntry = /* GraphQL */ `mutation CreatePlaceListEntry(
  $input: CreatePlaceListEntryInput!
  $condition: ModelPlaceListEntryConditionInput
) {
  createPlaceListEntry(input: $input, condition: $condition) {
    id
    placeList {
      id
      name
      description
      entries {
        items {
          id
          placeList {
            id
            name
            description
            createdAt
            updatedAt
            _version
            _deleted
            _lastChangedAt
            owner
            __typename
          }
          place
          order
          checked
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          placeListEntriesId
          owner
          __typename
        }
        nextToken
        startedAt
        __typename
      }
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      owner
      __typename
    }
    place
    order
    checked
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    placeListEntriesId
    owner
    __typename
  }
}
` as GeneratedMutation<
  APITypes.CreatePlaceListEntryMutationVariables,
  APITypes.CreatePlaceListEntryMutation
>;
export const updatePlaceListEntry = /* GraphQL */ `mutation UpdatePlaceListEntry(
  $input: UpdatePlaceListEntryInput!
  $condition: ModelPlaceListEntryConditionInput
) {
  updatePlaceListEntry(input: $input, condition: $condition) {
    id
    placeList {
      id
      name
      description
      entries {
        items {
          id
          placeList {
            id
            name
            description
            createdAt
            updatedAt
            _version
            _deleted
            _lastChangedAt
            owner
            __typename
          }
          place
          order
          checked
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          placeListEntriesId
          owner
          __typename
        }
        nextToken
        startedAt
        __typename
      }
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      owner
      __typename
    }
    place
    order
    checked
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    placeListEntriesId
    owner
    __typename
  }
}
` as GeneratedMutation<
  APITypes.UpdatePlaceListEntryMutationVariables,
  APITypes.UpdatePlaceListEntryMutation
>;
export const deletePlaceListEntry = /* GraphQL */ `mutation DeletePlaceListEntry(
  $input: DeletePlaceListEntryInput!
  $condition: ModelPlaceListEntryConditionInput
) {
  deletePlaceListEntry(input: $input, condition: $condition) {
    id
    placeList {
      id
      name
      description
      entries {
        items {
          id
          placeList {
            id
            name
            description
            createdAt
            updatedAt
            _version
            _deleted
            _lastChangedAt
            owner
            __typename
          }
          place
          order
          checked
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          placeListEntriesId
          owner
          __typename
        }
        nextToken
        startedAt
        __typename
      }
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      owner
      __typename
    }
    place
    order
    checked
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    placeListEntriesId
    owner
    __typename
  }
}
` as GeneratedMutation<
  APITypes.DeletePlaceListEntryMutationVariables,
  APITypes.DeletePlaceListEntryMutation
>;
export const createPlaceList = /* GraphQL */ `mutation CreatePlaceList(
  $input: CreatePlaceListInput!
  $condition: ModelPlaceListConditionInput
) {
  createPlaceList(input: $input, condition: $condition) {
    id
    name
    description
    entries {
      items {
        id
        placeList {
          id
          name
          description
          entries {
            nextToken
            startedAt
            __typename
          }
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          owner
          __typename
        }
        place
        order
        checked
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        placeListEntriesId
        owner
        __typename
      }
      nextToken
      startedAt
      __typename
    }
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    owner
    __typename
  }
}
` as GeneratedMutation<
  APITypes.CreatePlaceListMutationVariables,
  APITypes.CreatePlaceListMutation
>;
export const updatePlaceList = /* GraphQL */ `mutation UpdatePlaceList(
  $input: UpdatePlaceListInput!
  $condition: ModelPlaceListConditionInput
) {
  updatePlaceList(input: $input, condition: $condition) {
    id
    name
    description
    entries {
      items {
        id
        placeList {
          id
          name
          description
          entries {
            nextToken
            startedAt
            __typename
          }
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          owner
          __typename
        }
        place
        order
        checked
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        placeListEntriesId
        owner
        __typename
      }
      nextToken
      startedAt
      __typename
    }
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    owner
    __typename
  }
}
` as GeneratedMutation<
  APITypes.UpdatePlaceListMutationVariables,
  APITypes.UpdatePlaceListMutation
>;
export const deletePlaceList = /* GraphQL */ `mutation DeletePlaceList(
  $input: DeletePlaceListInput!
  $condition: ModelPlaceListConditionInput
) {
  deletePlaceList(input: $input, condition: $condition) {
    id
    name
    description
    entries {
      items {
        id
        placeList {
          id
          name
          description
          entries {
            nextToken
            startedAt
            __typename
          }
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          owner
          __typename
        }
        place
        order
        checked
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        placeListEntriesId
        owner
        __typename
      }
      nextToken
      startedAt
      __typename
    }
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    owner
    __typename
  }
}
` as GeneratedMutation<
  APITypes.DeletePlaceListMutationVariables,
  APITypes.DeletePlaceListMutation
>;
